import { useSetApplicationPreviousStepMutation } from "pages/application/applicationService";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentUserApplicationId, setLogout } from "features/authSlice";
import { useNavigate } from "react-router-dom";


const BackButton = () => {
  const { hasPreviousStep } = useSelector(getStepData);
  const [setPreviousQuestion, { isError, error }] = useSetApplicationPreviousStepMutation({
    fixedCacheKey: "updateApplication",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const applicationId = useSelector(getCurrentUserApplicationId);

  if (isError && typeof error === "object" && "status" in error && error.status === 401) {
    dispatch(setLogout());
    navigate("/", { replace: true, state: { previousPath: "/application" } });
  }

  if (!hasPreviousStep) return null;


  return (
    <div className="question-navigation__item question-navigation__item--back">
      <button
        type="button"
        className="btn btn--round btn--outline-primary question-navigation__back"
        onClick={async () => {
          await setPreviousQuestion({
            id: applicationId,
          });
        }}
      >
        Back
      </button>
    </div>
  );
};

export default BackButton;
